import { useChat } from '@/modules/chat/hooks';

import { Login } from '../Login';

export const LoginPage = () => {
    useChat();

    return <Login />;
};
